export const sampleData = [
  {
    id: 1,
    label: 'JuggernautXL',
    prompt: '1girl, chibi, green eyes, orange very long hair, messy hair, ahoge, hair between eyes, cat fluff ears, striped tail, white frilly blouse, black ribbon tie, beige long skirt,',
    negativePrompt: 'nsfw, (low quality, worst quality:1.2), very displeasing, 3d, watermark, signature, ugly, poorly drawn',
    imageUrl: 'https://files.catbox.moe/fjnrt3.png',
    visible: true,
    baseModel: 'SDXL',
  },
  {
    id: 2,
    label: 'waiREALMIX',
    prompt: 'score 9, score 8 up, score 7 up, 1girl, green eyes, orange very long hair, messy hair, ahoge, hair between eyes, cat fluff ears, striped tail, white frilly blouse, black ribbon tie, beige long skirt,',
    negativePrompt: 'score_6,score_5,score_4, worst quality, low quality, bad anatomy, bad hands, missing fingers, fewer digits, source_furry, source_pony, source_cartoon,3d, blurry,',
    imageUrl: 'https://files.catbox.moe/52a4w1.png',
    visible: true,
    baseModel: 'Pony',
  },
  {
    id: 3,
    label: 'waiREALCN',
    prompt: 'score 9, score 8 up, score 7 up, 1girl, green eyes, orange very long hair, messy hair, ahoge, hair between eyes, cat fluff ears, striped tail, white frilly blouse, black ribbon tie, beige long skirt,',
    negativePrompt: 'score_6,score_5,score_4,bad anatomy, bad hands, missing fingers, fewer digits, source_furry, source_pony, source_cartoon,3d, blurry, ',
    imageUrl: 'https://files.catbox.moe/hf3hm9.png',
    visible: true,
    baseModel: 'Pony',
  },
  {
    id: 4,
    label: 'Noobreal',
    prompt: '1girl, green eyes, orange very long hair, messy hair, ahoge, hair between eyes, cat fluff ears, striped tail, white frilly blouse, black ribbon tie, beige long skirt, realistic,',
    negativePrompt: 'blur, sketch, comic, cartoon, toon, oil painting (medium), flat color, outline, 3D, 2.5D, 2D, unreal, unity, blender, anime ,smooth skin,',
    imageUrl: 'https://files.catbox.moe/ygc7pi.png',
    visible: true,
    baseModel: 'Illustrious',
  },
  {
    id: 5,
    label: 'Redcraft',
    prompt: '1girl, green eyes, orange very long hair, messy hair, ahoge, hair between eyes, cat fluff ears, striped tail, white frilly blouse, black ribbon tie, beige long skirt,',
    negativePrompt: 'low quality,ugly,deformed,bad anatomy,extra fingers,censored',
    imageUrl: 'https://files.catbox.moe/3iort6.png',
    visible: true,
    baseModel: 'Illustrious',
  },
  {
    id: 6,
    label: 'PornMasterPro',
    prompt: '1girl, green eyes, orange very long hair, messy hair, ahoge, hair between eyes, cat fluff ears, striped tail, white frilly blouse, black ribbon tie, beige long skirt, realistic,',
    negativePrompt: 'lowres, worst aesthetic, bad quality, worst quality, bad anatomy, jpeg artifacts, scan artifacts, lossy-lossless, unfinished, ugly, poorly drawn, greyscale, (illustration, 2d, 2.5D, 3d, painting (medium), toon (style), sketch, comic, anime,flat color,outline,smooth skin:1.2) watermark, text, extra digits',
    imageUrl: 'https://files.catbox.moe/8rq5ad.png',
    visible: true,
    baseModel: 'Illustrious',
  },
  {
    id: 7,
    label: 'ANIMAGINE',
    prompt: '1girl, chibi, green eyes, orange very long hair, messy hair, ahoge, hair between eyes, cat fluff ears, striped tail, white frilly blouse, black ribbon tie, beige long skirt,',
    negativePrompt: 'lowres, bad anatomy, bad hands, text, error, missing finger, extra digits, fewer digits, cropped, worst quality, low quality, low score, bad score, average score, signature, watermark, username, blurry',
    imageUrl: 'https://files.catbox.moe/nyk27j.png',
    visible: true,
    baseModel: 'SDXL',
  },
  {
    id: 8,
    label: 'ArtiWaifu',
    prompt: '1girl, chibi, green eyes, orange very long hair, messy hair, ahoge, hair between eyes, cat fluff ears, striped tail, white frilly blouse, black ribbon tie, beige long skirt,',
    negativePrompt: 'nsfw, lowres, (bad), text, error, fewer, extra, missing, worst quality, jpeg artifacts, low quality, watermark, unfinished, displeasing, oldest, early, chromatic aberration, signature, extra digits, artistic error, username, scan, [abstract]',
    imageUrl: 'https://files.catbox.moe/1nr6u5.png',
    visible: true,
    baseModel: 'SDXL',
  },
  {
    id: 9,
    label: 'AnythingXL',
    prompt: '1girl, chibi, green eyes, orange very long hair, messy hair, ahoge, hair between eyes, cat fluff ears, striped tail, white frilly blouse, black ribbon tie, beige long skirt,',
    negativePrompt: 'nsfw, lowres, bad anatomy, bad hands, text, error, missing fingers, extra digit, fewer digits, cropped, worst quality, low quality, normal quality, jpeg artifacts, signature, watermark, username, blurry, artist name',
    imageUrl: 'https://files.catbox.moe/e4mdnb.png',
    visible: true,
    baseModel: 'SDXL',
  },
  {
    id: 10,
    label: 'Pony',
    prompt: 'score 9, score 8 up, score 7 up, 1girl, chibi, green eyes, orange very long hair, messy hair, ahoge, hair between eyes, cat fluff ears, striped tail, white frilly blouse, black ribbon tie, beige long skirt,',
    negativePrompt: 'low quality , bad anatomy, bad proportions, extra legs, deformed anatomy, messy color, deformed fingers, bad, distracted, hyperrealistic,source_furry, source_pony, source_cartoon',
    imageUrl: 'https://files.catbox.moe/pczbqh.png',
    visible: true,
    baseModel: 'Pony',
  },
  {
    id: 11,
    label: '7thAnimeXLPony',
    prompt: 'score 9, score 8 up, score 7 up, 1girl, chibi, green eyes, orange very long hair, messy hair, ahoge, hair between eyes, cat fluff ears, striped tail, white frilly blouse, black ribbon tie, beige long skirt,',
    negativePrompt: 'score_4,score_5,score_6,source_pony,source_furry,monochrome,3d,photo,hyperrealistic,realstic,rough sketch,fewer digits,extra digits,signature,artist name,',
    imageUrl: 'https://files.catbox.moe/4est01.png',
    visible: true,
    baseModel: 'Pony',
  },
  {
    id: 12,
    label: '3x3x3mixxl',
    prompt: 'score 9, score 8 up, score 7 up, 1girl, chibi, green eyes, orange very long hair, messy hair, ahoge, hair between eyes, cat fluff ears, striped tail, white frilly blouse, black ribbon tie, beige long skirt,',
    negativePrompt: 'score_6 , score_5 , score_4 , source_furry, source_pony, source_cartoon,',
    imageUrl: 'https://files.catbox.moe/kh5nrn.png',
    visible: true,
    baseModel: 'Pony',
  },
  {
    id: 13,
    label: 'NovaAnimeXL',
    prompt: '1girl, chibi, green eyes, orange very long hair, messy hair, ahoge, hair between eyes, cat fluff ears, striped tail, white frilly blouse, black ribbon tie, beige long skirt,',
    negativePrompt: 'modern, recent, old, oldest, cartoon, graphic, text, painting, crayon, graphite, abstract, glitch, deformed, mutated, ugly, disfigured, long body, lowres, bad anatomy, bad hands, missing fingers, extra digit, fewer digits, cropped, very displeasing, (worst quality, bad quality:1.2), bad anatomy, sketch, jpeg artifacts, signature, watermark, username, signature, simple background, conjoined,bad ai-generated',
    imageUrl: 'https://files.catbox.moe/xcrbtj.png',
    visible: true,
    baseModel: 'Illustrious',
  },
  {
    id: 14,
    label: 'WaiNSFWIllustrious',
    prompt: '1girl, chibi, green eyes, orange very long hair, messy hair, ahoge, hair between eyes, cat fluff ears, striped tail, white frilly blouse, black ribbon tie, beige long skirt,',
    negativePrompt: 'bad quality,worst quality,worst detail,sketch,censor',
    imageUrl: 'https://files.catbox.moe/hv85ra.png',
    visible: true,
    baseModel: 'Illustrious',
  },
  {
    id: 15,
    label: 'ShiitakeMix',
    prompt: '1girl, chibi, green eyes, orange very long hair, messy hair, ahoge, hair between eyes, cat fluff ears, striped tail, white frilly blouse, black ribbon tie, beige long skirt,',
    negativePrompt: '(bad quality,worst quality,low quality,bad anatomy,bad hand:1.3), nsfw, lowres, bad anatomy, bad hands, text, error, missing fingers, extra digit, fewer digits, cropped, worst quality, low quality, normal quality, jpeg artifacts, signature, watermark, username, blurry, artist name,',
    imageUrl: 'https://files.catbox.moe/1eobhk.png',
    visible: true,
    baseModel: 'Illustrious',
  },
  {
    id: 16,
    label: 'MatureRitual',
    prompt: '1girl, green eyes, orange very long hair, messy hair, ahoge, hair between eyes, cat fluff ears, striped tail, white frilly blouse, black ribbon tie, beige long skirt,',
    negativePrompt: 'bad quality,worst quality,worst detail,sketch,censor',
    imageUrl: 'https://files.catbox.moe/lg76ra.png',
    visible: true,
    baseModel: 'Illustrious',
  },
  {
    id: 17,
    label: 'NovaFurryXL',
    prompt: '1girl, chibi, green eyes, orange very long hair, messy hair, ahoge, hair between eyes, cat fluff ears, striped tail, white frilly blouse, black ribbon tie, beige long skirt,',
    negativePrompt: 'human, multiple tails, modern, recent, old, oldest, graphic, cartoon, text, painting, crayon, graphite, abstract, glitch, deformed, mutated, ugly, disfigured, long body, lowres, bad anatomy, bad hands, missing fingers, extra digits, fewer digits, cropped, very displeasing, (worst quality, bad quality:1.2), bad anatomy, sketch, jpeg artifacts, signature, watermark, username, simple background, conjoined, bad ai-generated',
    imageUrl: 'https://files.catbox.moe/5l1s4v.png',
    visible: true,
    baseModel: 'Illustrious',
  },
  {
    id: 18,
    label: 'PVCRealistic',
    prompt: '1girl, chibi, green eyes, orange very long hair, messy hair, ahoge, hair between eyes, cat fluff ears, striped tail, white frilly blouse, black ribbon tie, beige long skirt,',
    negativePrompt: 'lowres,(bad),text,error,fewer,extra,missing,worst quality,jpeg artifacts,low quality,watermark,unfinished,displeasing,oldest,early,chromatic aberration,artistic error,username,english text,scan,[abstract],',
    imageUrl: 'https://files.catbox.moe/eeeals.png',
    visible: true,
    baseModel: 'SDXL',
  },
  {
    id: 19,
    label: 'PVCMovable',
    prompt: 'score 9, score 8 up, score 7 up, 1girl, chibi, green eyes, orange very long hair, messy hair, ahoge, hair between eyes, cat fluff ears, striped tail, white frilly blouse, black ribbon tie, beige long skirt,',
    negativePrompt: 'engrish text,low quality,worstquality,shiny_skin,score_4,score_3,score_2,score_1,ugly,bad feet,bad hands,',
    imageUrl: 'https://files.catbox.moe/jyyryb.png',
    visible: true,
    baseModel: 'Pony',
  },
]